import axios from 'axios'
import jwt from 'jsonwebtoken'

const enviroment = process.env.NODE_ENV
const tokenName = `eemovel_audit_token_${enviroment}`
const refreshTokenName = `eemovel_audit_refresh_token_${enviroment}`
const credentialName = `eemovel_audit_credential_${enviroment}`
const apiKeyName = `eemovel_audit_api_key_${enviroment}`

const API_URL = process.env.REACT_APP_AUTH_API_URL
const SIGN_IN = `${API_URL}users/public/sign-in`
const REFRESH_TOKEN = `${API_URL}users/public/refresh`
const API_KEY = `${API_URL}providers/api-key`
const USER_INFO = `${API_URL}audit/user-info`

export const headers = () => ({
  'x-api-key': `${localStorage.getItem(apiKeyName)}`,
  Authorization: `${localStorage.getItem(tokenName)}`,
  'Content-Type': 'application/json',
})

export const login = async ({ email, password }, loading, setError) => {
  try {
    loading(true)
    setError('')
    const signInResponse = await axios.post(SIGN_IN, { email, password })
    const resfreshResponse = await axios.post(REFRESH_TOKEN, {
      RefreshToken: signInResponse?.data?.data?.RefreshToken,
    })

    const idToken = resfreshResponse?.data?.data?.IdToken

    if (idToken) {
      await axios.get(USER_INFO, {
        headers: { Authorization: idToken },
      })
      const userInformation = jwt.decode(idToken)
      const apiKey = await axios.get(API_KEY, {
        headers: { Authorization: idToken },
      })

      const refreshToken = signInResponse?.data?.data?.RefreshToken
      const apiKeyNameValue = apiKey?.data?.data?.api_key

      localStorage.setItem(refreshTokenName, refreshToken)
      localStorage.setItem(credentialName, JSON.stringify(userInformation))
      localStorage.setItem(tokenName, idToken)
      localStorage.setItem(apiKeyName, apiKeyNameValue)

      window.location = '/busca'
    }
  } catch (err) {
    const status = err?.response?.status
    if (status === 401) setError('Usuário ou senha incorretos')
    if (status === 403) {
      setError('Você não tem acesso a esse produto.')
      logout(false)
    }
    console.error(err)
  }

  loading(false)
}

export const authed = () => {
  const token = localStorage.getItem(tokenName)
  return !!token
}

export const cityId = () => getCityIdLocalStorage() || 5270
export const getCityIdLocalStorage = () => sessionStorage.getItem('cityId')
export const setCityIdLocalStorage = cityId =>
  sessionStorage.setItem('cityId', cityId)

export const getUserInfo = () =>
  JSON.parse(localStorage.getItem(credentialName))

export const getApiKey = () => localStorage.getItem(apiKeyName)

export const getToken = () => localStorage.getItem(tokenName)

export const refreshToken = async () => {
  const resfreshResponse = await axios.post(REFRESH_TOKEN, {
    RefreshToken: localStorage.getItem(refreshTokenName),
  })

  const idToken = resfreshResponse?.data?.data?.IdToken

  if (idToken) {
    localStorage.setItem(tokenName, idToken)
  }
}

export const logout = (redirect = true) => {
  localStorage.removeItem(tokenName)
  localStorage.removeItem(credentialName)
  localStorage.removeItem(apiKeyName)

  if (redirect) window.location = '/'
}
